// src/StaffPage.js
//
// UPDATED to full CRUD. Uses department_label for display.

import { useState, useEffect } from 'react';
import { API_BASE_URL } from './apiConfig';
import StaffForm from './StaffForm';

function StaffPage({ token }) {
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingStaff, setEditingStaff] = useState(null);

  const refreshStaff = () => {
    fetch(`${API_BASE_URL}/api/staff/`, {
      headers: { Authorization: `Token ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setStaffList(data);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshStaff();
  }, [token]);

  const handleNewClick = () => { setEditingStaff(null); setShowForm(true); };
  const handleEditClick = (s) => { setEditingStaff(s); setShowForm(true); };
  const handleSaved = () => { setShowForm(false); setEditingStaff(null); refreshStaff(); };
  const handleCancel = () => { setShowForm(false); setEditingStaff(null); };

  const handleDelete = async (s) => {
    const confirmed = window.confirm(`Delete staff member "${s.full_name}"? This cannot be undone.`);
    if (!confirmed) return;
    await fetch(`${API_BASE_URL}/api/staff/${s.id}/`, {
      method: 'DELETE',
      headers: { Authorization: `Token ${token}` },
    });
    refreshStaff();
  };

  if (loading) return <p className="text-gray-500">Loading staff...</p>;

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Staff</h1>
        <button onClick={handleNewClick} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          + New Staff Member
        </button>
      </div>

      {showForm && (
        <StaffForm token={token} staffMember={editingStaff} onSaved={handleSaved} onCancel={handleCancel} />
      )}

      <table className="w-full bg-white rounded shadow">
        <thead>
          <tr className="text-left border-b">
            <th className="p-3">Full Name</th>
            <th className="p-3">Department</th>
            <th className="p-3">Job Title</th>
            <th className="p-3">Email</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {staffList.map((person) => (
            <tr key={person.id} className="border-b hover:bg-gray-50">
              <td className="p-3">{person.full_name}</td>
              <td className="p-3">{person.department_label || 'N/A'}</td>
              <td className="p-3">{person.job_title}</td>
              <td className="p-3">{person.email}</td>
              <td className="p-3">
                <button onClick={() => handleEditClick(person)} className="text-blue-600 text-sm hover:underline mr-3">Edit</button>
                <button onClick={() => handleDelete(person)} className="text-red-600 text-sm hover:underline">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default StaffPage;
